import { Component } from 'preact';
import { renderRoutes } from 'react-router-config';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import MutationAndCurrencyHelper from '../helpers/MutationAndCurrencyHelper';

class OuterLayout extends Component {

	componentDidMount() {
		MutationAndCurrencyHelper.updateMutationAndCurrencyIfRequired(
			null,
			null,
			MutationAndCurrencyHelper.getMutationParam(this.props.match),
			MutationAndCurrencyHelper.getCurrencyParam(this.props.match)
		);
	}

	componentWillUpdate(nextProps, nextState) {
		let currentMutation = MutationAndCurrencyHelper.getMutationParam(this.props.match);
		let currentCurrency = MutationAndCurrencyHelper.getCurrencyParam(this.props.match);
		let updatedMutation = MutationAndCurrencyHelper.getMutationParam(nextProps.match);
		let updatedCurrency = MutationAndCurrencyHelper.getCurrencyParam(nextProps.match);

		if (currentMutation !== updatedMutation || currentCurrency !== updatedCurrency) {
			MutationAndCurrencyHelper.updateMutationAndCurrencyIfRequired(currentMutation, currentCurrency, updatedMutation, updatedCurrency);
		}
	}

	render = ({ route, location, initialized, preloader }) => (
		<div id="outer-container" className="h-100">
			<CSSTransition in={initialized} classNames="fade" timeout={700} unmountOnExit>
				{renderRoutes(route.routes)}
			</CSSTransition>
			<CSSTransition in={preloader} classNames="fade" timeout={700} unmountOnExit>
				<div className={'h-100 overlay'}>
					<div className="row h-100 justify-content-center align-items-center">
						<span className="scale">
							<i className="fa fa-spinner fa-spin fa-4x" />
						</span>
					</div>
				</div>
			</CSSTransition>
		</div>
	);
}

const mapStateToProps = (state) => {
	const { ui } = state;
	return {
		mutation: ui.mutation,
		currency: ui.currency,
		defaultMutation: ui.defaultMutation,
		defaultCurrency: ui.defaultCurrency,
		preloader: ui.preloader,
		initialized: ui.initialized
	};
};

export default connect(mapStateToProps)(OuterLayout);



// WEBPACK FOOTER //
// ./components/OuterLayout.js